import React from 'react';
import classes from "./info.module.css";

const Info = () => {
    return (
        <div className={classes._}>
            <div>Остались вопросы? Напиши нам: <a className={classes.link} href={'https://t.me/easyfastvpn'}>@easyfastvpn</a></div>
        </div>
    );
};

export default Info;